import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker, LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { InputLabel, TextField, InputAdornment, Box, Typography } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { makeStyles } from "tss-react/mui";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import dayjs from "dayjs";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const useStyles = makeStyles()((theme) => {
    return {
        datePicker: {
            width: "100%",
            ".MuiInputBase-root:hover fieldset": {
                borderColor: `#c4c4c4 !important`,
            },
            "input": {
                padding: "6px 12px 6px 12px !important",
            },
            "& .MuiInputBase-root.MuiOutlinedInput-root": {
                borderRadius: "10px !important",
                flexDirection: "row-reverse"
            },
            "& .MuiInputAdornment-root": {
                margin: "0px 5px 0px 0px"
            },
            ".Mui-focused": {
                borderColor: `red !important`,
                // borderWidth: "1px !important",
            },
            ".MuiSvgIcon-root": {
                color: "#3E4094",
                fontSize: "22px"
            },
            ".MuiInputBase-input": {
                height: "24px",
            },
        },
    };
});

const CommonDatePicker = ({
    size,
    placeholder,
    name,
    value,
    label,
    onChange,
    inputFormat = "DD/MM/YYYY",
    maxDate,
    minDate,
    fontWeight,
    labelSize,
    labelColor,
    whiteSpace,
    valid,
    width,
    disabled,
    disableFuture,
    disablePast,
    readOnly,
    height,
    subText
}) => {
    const { classes } = useStyles();
    return (
        <div style={{ width: "100%" }}>
            {label && (
                <Box mb={0.5} display="flex" fontSize="12px" flexDirection={"row"}>
                    <Box display="flex" fontSize="12px" flexDirection={"column"} flexWrap={"wrap"} >
                        <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: labelSize || "14px",
                                color: labelColor || "#222222",
                                whiteSpace: whiteSpace ? "wrap" : "nowrap",
                                marginBottom: "0px"
                            }}
                        >
                            {label}
                        </InputLabel>
                        {subText && <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: "11px",
                                color: labelColor || "#222222",
                                whiteSpace: whiteSpace ? "wrap" : "nowrap",
                            }}
                        >
                            {subText}
                        </InputLabel>}
                    </Box>
                    {valid && (
                        <Typography color="#EF627A" component={"caption"} variant={"body2"}>
                            *
                        </Typography>
                    )}
                </Box>
            )}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box width={width}>
                    <DesktopDatePicker
                        className={classes.datePicker}
                        readOnly={readOnly ? readOnly : false}
                        value={value ? dayjs(value, inputFormat, true) : null}
                        // value={value ? dayjs(value, 'YYYY/MM/DD', true) : null}
                        onChange={onChange}
                        disabled={disabled}
                        minDate={minDate}
                        maxDate={maxDate}
                        disableFuture={disableFuture}
                        disablePast={disablePast}
                        inputFormat={inputFormat}
                        format={inputFormat}
                        sx={{
                            ".MuiInputBase-input": {
                                height: height || "28px",
                            },
                        }}
                        renderInput={(params) => (
                            <TextField
                                placeholder={placeholder ? placeholder : "Select Date"}
                                name={name}
                                InputProps={{
                                    readOnly: readOnly || false,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <CalendarTodayOutlinedIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                {...params}
                            />
                        )}
                    />
                </Box>
            </LocalizationProvider>
        </div>
    );
};

export default CommonDatePicker;

